

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Popupslot from './components/popupslot.vue';
import Top3Cell from './components/top3Cell.vue';
import BlockCell from './components/blockCell.vue';
import { isBlackMode } from '@/common/untils/newUtils.ts';
import { getBlockTop } from '../../service/index';
import {
  screenShare,
  listenShareResult,
  testEvent,
} from '@/common/untils/share.ts';
import Bus from '../../../../common/js/eventBus';
const NO_MESSAGE = '暂无数据';
const win: any = window;
@Component({
  components: {
    Popupslot,
    Top3Cell,
    BlockCell,
  },
})
export default class BestTureye extends Vue {
  private popupRoundShow = false;
  private isBlack = isBlackMode();
  private popupPosition = '';
  private popupRoundPosition = '';
  private scrollTop = 0;
  private tempTop: any = 0;
  private btnFlag = false;
  private itemList = ['block0', 'block1', 'block2'];
  private blockList: any = [];
  private screentHeight = 200;
  private topList: any = [];
  private maidian = 'free_ztjj.zqfk';
  private startX = 0;
  private startY = 0;
  private slideflag = true;
  private sh = 100;
  private loadtag = true;
  private nowFilter = 'HS,GEM2STAR';
  private nowDate = '';
  private fixPageHeight = 85;
  private noDataMessage = NO_MESSAGE; // 无数据展示文本

  private mounted() {
    document.addEventListener('touchstart', this.startBehavior, false);
    document.addEventListener('touchmove', this.moveBehavior, false);

    win.addEventListener('scroll', this.scrollToTop);

    setTimeout(() => {
      const length = this.blockList ? this.blockList.length : 0;
      if (length >= 4) {
        // alert('leng>3')
        // const ele: any = document.querySelector(`#${this.blockList[3].name}`);
        const ele: any = document.getElementById(`${this.blockList[3].name}`);
        this.sh = ele.offsetTop;
      } else if (length > 0) {
        const ele: any = document.getElementById(
          `${this.blockList[length - 1].name}`,
        );
        this.sh = ele.offsetTop;
        if (this.sh < 1800) {
          this.sh = 1800;
        }
      } else {
        this.sh = 2000;
      }

      screenShare(`${this.maidian}.share`, this.sh);
      listenShareResult(`${this.maidian}.share`);
    }, 500);
    Bus.$on('PopupHide', (e: any) => {
      this.popupRoundShow = false;
    });
  }

  private destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);

    document.removeEventListener('touchstart', this.startBehavior);
    document.removeEventListener('touchmove', this.moveBehavior);
  }
  private handlePopupShow(position = '') {
    Bus.$emit('PopupShow');

    this.tempTop = this.scrollTop;
    this.popupRoundPosition = position;
    this.popupRoundShow = true;
  }

  private handlePopupRoundHide() {
    Bus.$emit('PopupHide');
    this.popupRoundShow = false;
  }

  private backTop() {
    const timer = setInterval(() => {
      const ispeed = Math.floor(-this.scrollTop / 5);
      document.documentElement.scrollTop = document.body.scrollTop =
        this.scrollTop + ispeed;
      if (this.scrollTop <= 0) {
        clearInterval(timer);
      }
    }, 16);
  }

  private scrollToTop() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    this.scrollTop = scrollTop;
    if (this.scrollTop > 667) {
      this.btnFlag = true;
    } else {
      this.btnFlag = false;
    }
  }
  private created() {
    const htmlFont: any = win.document.getElementsByTagName('html')[0].style
      .fontSize;
    const font: any = htmlFont.substr(0, htmlFont.indexOf('px'));
    this.fixPageHeight = 1.9 * font;
    const sercretNum = new Date().getTime();
    //window上的对象存在
    let params: any = {};
    if (win.changeRouteBus) {
      params = {
        filter: win.changeRouteBus.filter,
        date: win.changeRouteBus.date,
      };
      this.nowFilter = win.changeRouteBus.filter;
      this.nowDate = win.changeRouteBus.date;
    } else {
      params = {
        filter: this.nowFilter,
        date: this.nowDate,
        // sercret: sercretNum
      };
    }

    this.initData(params);
    this.getChangeRoute();
  }
  private changeRouteFun(e: any) {
    if (e && e.path && e.path === '/bestTureye') {
      this.nowFilter = e.filter ? e.filter : this.nowFilter;
      this.nowDate = e.date ? e.date : this.nowDate;
      const sercretNum = new Date().getTime();
      const params = {
        filter: this.nowFilter,
        date: this.nowDate,
        // _: sercretNum
      };
      this.loadtag = true;
      this.initData(params);
    }
  }
  private getChangeRoute() {
    Bus.$on('changeRoute', this.changeRouteFun);
  }
  private beforeDestroy() {
    Bus.$off('changeRoute', this.changeRouteFun);
  }
  @Watch('$route', { immediate: true, deep: true })
  routeWatch(to: any, from: any) {
    // this.nowFilter = to.query.filter ? to.query.filter : this.nowFilter;
    // this.nowDate = to.query.date ? to.query.date : this.nowDate;
    // const sercretNum = new Date().getTime();
    // const params = {
    //   filter: this.nowFilter,
    //   date: this.nowDate
    //   // _: sercretNum
    // };
    // this.initData(params);
    win.callNativeHandler('notifyWebHandleEvent', {
      method: 'setTitleBar',
      params: {
        rightViewType: 'ShareImageView', //右上角功能的类型
        stopSetNil: 'yes', //显示右上角按钮
      },
    });
  }
  private async initData(params: any) {
    try {
      const data = await getBlockTop(params);
      this.blockList = data.data;
     // 10003和后端协议 开盘前状态码10003， 显示对应文案
      if(data.status_code === 10003) {
        this.noDataMessage = data.status_msg.replace('\n', '</br>');
      }else {
        this.noDataMessage = NO_MESSAGE;
      }
      this.loadtag = false;
    } catch (error) {
      console.log('initData', error);
      this.loadtag = false;
    }
  }

  private goAnchor(itemId: string, topSend?: any) {
    // alert('click'+itemId)
    Bus.$emit('PopupHide');
    this.popupRoundShow = false;
    // console.log(document.querySelector("#" + itemId));
    // const anchor: any = document.querySelector("#" + itemId);
    const anchor: any = document.getElementById(itemId);
    // document.querySelector("#" + itemId)!.scrollIntoView();
    let top: any;
    if (topSend == 'fromTop') {
      top = anchor.offsetTop - this.fixPageHeight;
    } else {
      top = anchor.offsetTop - this.fixPageHeight + this.fixPageHeight;
    }
    const scrollTop: any = this.tempTop;
    let currentTop = scrollTop;
    let requestId: any;
    const stepsize = (top - currentTop) / 5;
    function step() {
      //向下还是向上滚
      if (scrollTop <= top) {
        if (currentTop + stepsize < top) {
          window.scrollTo(0, currentTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.scrollTo(0, top);
          window.cancelAnimationFrame(requestId);
        }
        //向下滚动
        currentTop += stepsize;
      } else {
        if (top < currentTop) {
          window.scrollTo(0, currentTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.scrollTo(0, top);
          window.cancelAnimationFrame(requestId);
        }
        //to top
        currentTop += stepsize;
      }
    }
    window.requestAnimationFrame(step);
  }

  private startBehavior(ev: any) {
    this.startX = ev.touches[0].pageX;
    this.startY = ev.touches[0].pageY;
  }

  private moveBehavior(ev: any) {
    if (this.slideflag) {
      const endX = ev.changedTouches[0].pageX;
      const endY = ev.changedTouches[0].pageY;
      this.getSlideDirection(this.startX, this.startY, endX, endY);
    }
  }

  private getSlideDirection(
    startX: number,
    startY: number,
    endX: number,
    endY: number,
  ) {
    const dy = startY - endY;
    let result = 0;
    if (dy > 0) {
      win.hxmClickStat(`${this.maidian}.shanghua`, { url_ver: 'F10-1725' });
      this.slideflag = false;
      result = 1;
    } else if (dy < 0) {
      result = 2;
    }
  }
}
